<template>
  <nav-bar :menuItems="menuItems" :portalButton="true" />
</template>
<script>
export default {
	name: "NavigationBarTrace",
	data: () => ({
		menuItems: [
			{ title: "Sender", link: "/trace/sender" },
			{ title: "Receiver", link: {name: "Receiver View"} },
			{ title: "Search", link:  {name: "Search Transactions"} },
			{ title: "Internal Comments", link: "/trace/comments" },
		],
		sidebar: false,
	}),
}
</script>